<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle title="Active Backlog"></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDownloadPdfIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-pdf-download="downloadPDF"
          ></HeaderControl>
        </div>
        <div class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <ShowHideCheckobox
            :show="true"
            @toggleData="toggleData($event, $refs.backRef)"
          ></ShowHideCheckobox>
        </div>
        <FooterOptions
          :showTop10="true"
          :showOverall="true"
          :showAll="true"
          :overallUrl="
            isCelia
              ? '/base/TableAllDataC?type=oembacklog'
              : '/base/TableAllDataPaginated?type=OEM&client_location=All'
          "
          @top-10-all-data-emit="top10AllDataEmit"
        ></FooterOptions>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import { Switch as cSwitch } from "@coreui/vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import FooterOptions from "../shared/FooterOptions.vue";
import { isCurrentUser, isUserLoggedIn, toggleData } from "../../utils/Utils";
import ShowHideCheckobox from "../shared/ShowHideCheckobox.vue";
import { OEMBacklogStackedChart } from "../../utils/ChartProps";
import Constants from "../../utils/Constants";
exporting(Highcharts);

export default {
  name: "BacklogStackedOEM",
  components: {
    router,
    highcharts: Chart,
    cSwitch,
    Highcharts,
    HeaderTitle,
    HeaderControl,
    LoadingCard,
    FooterOptions,
    ShowHideCheckobox
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      toggleData: toggleData,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      isCelia: false,
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      city: "",
      chartOptions: {}
    };
  },

  watch: {
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },

  methods: {
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;

      let params = {};
      params = {
        chartType: "OEM-backlog"
      };
      this.$http
        .get("api/charts/chart_data.php", {
          params
        })
        .then(
          res => {
            let getReady = res.data.stackedData;
            let myArray = getReady;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Fiber Gear",
              data: [],
              color: "rgb(124, 181, 236)"
            };
            var power = {
              name: "Power Supply",
              data: [],
              color: "rgb(247, 163, 92)"
            };
            var line = {
              name: "Line Gear",
              data: [],
              color: "rgb(144, 237, 125)"
            };
            var meter = {
              name: "Meter",
              data: [],
              color: "rgb(145, 232, 225)"
            };
            var transponder = {
              name: "Transponder",
              data: [],
              color: "rgb(241, 92, 128)"
            };
            var headend = {
              name: "Headend",
              data: [],
              color: "rgb(43, 144, 143)"
            };
            var wireless = {
              name: "Wireless",
              data: [],
              color: "rgb(23, 114, 143)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }
            datum.sort((a, b) =>
              parseFloat(a[1].Total) > parseFloat(b[1].Total) ? -1 : 1
            );
            if (!this.showAll) {
              datum = datum.slice(0, 10);
            }
            datum.forEach(obj => {
              xAxis.push(obj[0]);
              Object.entries(obj[1]).forEach(([key, value]) => {
                var tempValue = parseInt(value);

                switch (key) {
                  case "Fiber Gear":
                    fiber.data.push(tempValue);

                    break;
                  case "Power Supply":
                    power.data.push(tempValue);

                    break;
                  case "Line Gear":
                    line.data.push(tempValue);

                    break;
                  case "Meter":
                    meter.data.push(tempValue);

                    break;
                  case "Transponder":
                    transponder.data.push(tempValue);
                    break;
                  case "Headend":
                    headend.data.push(tempValue);
                    break;
                  case "Wireless":
                    wireless.data.push(tempValue);
                    break;
                }
              });
            });
            if (!this.showAll) {
              this.chartOptions.xAxis.categories = xAxis.slice(0, 10);
            } else {
              this.chartOptions.xAxis.categories = xAxis;
            }
            this.chartOptions.series[0] = fiber;
            this.chartOptions.series[1] = power;
            this.chartOptions.series[2] = line;
            this.chartOptions.series[3] = meter;
            this.chartOptions.series[4] = transponder;
            this.chartOptions.series[5] = headend;
            this.chartOptions.series[6] = wireless;

            this.chartOptions.tooltip.formatter = function() {
              return (
                "<b>" +
                this.x +
                "</b><br>" +
                this.series.name +
                ": " +
                this.y +
                " units"
              );
            };

            this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
              return this.y;
            };

            this.chartOptions.yAxis.stackLabels.formatter = function() {
              return "Total: " + this.total;
            };

            this.chartOptions.title.text = "Total units: " + res.data.totals;

            this.loadingData = false;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "OEM-Active Backlog | " + this.dateTo;
      } else {
        this.$refs.backRef.chart.options.title.text =
          "OEM-Active Backlog | " + this.dateTo + " " + this.nameCity;
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.options.yAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "OEM-ActiveBacklog-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.isCelia = isCurrentUser(Constants.CELIA, Constants.REACHEL);
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.chartOptions = OEMBacklogStackedChart(
      router,
      this.locParam,
      this.city,
      this.locationsIds
    );
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
